import React, { useEffect } from 'react';
import Icon from '../common/Icon';
import { trackSubscriptionPromptViewed } from '../../utils/speakrootsAnalytics.js';

const PaywallModal = ({ isOpen, onClose, onViewPlans }) => {
  // Track subscription prompt viewed when modal opens
  useEffect(() => {
    if (isOpen) {
      trackSubscriptionPromptViewed('locked_lesson');
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

      // Scroll to top smoothly when modal opens
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Prevent background scrolling
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      
    // Handle escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    
    // CRITICAL CLEANUP - Prevents button timeout issues
      return () => {
        document.body.style.overflow = originalOverflow;
      document.removeEventListener('keydown', handleEscape);
      
      // Force cleanup any lingering active states
      setTimeout(() => {
        const activeElements = document.querySelectorAll('[aria-expanded="true"]');
        activeElements.forEach(el => el.setAttribute('aria-expanded', 'false'));
        
        // Remove any stuck focus states
        const focusedElements = document.querySelectorAll(':focus');
        focusedElements.forEach(el => el.blur());
      }, 100);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Check if device is mobile
  const isMobile = window.innerWidth < 1024;

  const content = (
    <div className="text-center">
      <span className="text-6xl mb-4 block"><Icon name="rocket" /></span>
      <p className="text-gray-600 mb-6">You've sampled this lesson. Subscribe now to unlock all units of content and continue the journey.</p>
      <div className="space-y-3">
        <button 
          onClick={onViewPlans} 
          className="w-full bg-green-500 text-white font-bold py-4 rounded-xl transition active:scale-95 min-h-[48px]"
        >
          View Plans
        </button>
        <button 
          onClick={onClose} 
          className="w-full text-gray-600 font-bold py-3 min-h-[44px]"
        >
          Maybe Later
        </button>
      </div>
    </div>
  );

  // Use bottom sheet on mobile, center modal on desktop
  if (isMobile) {
    return (
      <div 
        className="fixed inset-0 z-[999999] flex items-center justify-center p-4 bg-black bg-opacity-60"
        onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      >
        <div 
          className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-2xl font-bold mb-4">Continue Your Adventure!</h2>
          {content}
        </div>
      </div>
    );
  }

  // Desktop version (center modal)
  return (
    <div 
      className="fixed inset-0 z-[999999] flex items-center justify-center p-4 bg-black bg-opacity-60"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div 
        className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="text-6xl mb-4"><Icon name="rocket" /></span>
        <h2 className="text-2xl font-extrabold mb-2">Continue Your Adventure!</h2>
        {content}
      </div>
    </div>
  );
};

export default PaywallModal;